
'use strict';//Indicating browser should run only in java script mode


; (function () {


    var StatusCustomizationRoutes = [
        {
            "name": "Appt_Status_Customization",
            "templateUrl": "<div emr-appointment-group-therapy-status></div>",
            "RoutingNumber": 973,
            "settingId": 51,
            files: [
                "AngularScripts/StatusCustomization/Services/AppointmentGroupTherapyStatusService.js",
                "AngularScripts/StatusCustomization/Directives/AppointmentGroupTherapyStatusController.js"
            ]
        },
    ];



    angular.module('EMR.StatusCustomizationModule', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(StatusCustomizationRoutes, $stateProvider);
            }]);
})();
